<div class="row filter_wrapper container py-4">
  <div
    *ngIf="headerFilter?.header || headerFilter.headerButton"
    class="col-md-12 filter_wrapper_heading"
  >
    <label *ngIf="headerFilter?.header" class="text-2xl fw-600">{{
      headerFilter.header
    }}</label>

    <ng-container *ngIf="headerFilter.headerButton">
      <button
        class="btn btn-secondary d-flex align-items-center gap-2"
        (click)="headerFilter.headerButton.onClick?.()"
      >
        <img width="18" height="18" src="images/add-white.svg" alt="Add" />
        <span>{{ headerFilter.headerButton.text }}</span>
      </button>
    </ng-container>
  </div>

  <div
    *ngIf="headerFilter?.description"
    class="col-md-8 description flex-grow-1"
  >
    <app-section-description>
      {{ headerFilter.description }}
    </app-section-description>
  </div>

  <!-- Show Filters -->

  <ng-container *ngIf="isShowFilter; else showSearchOnlyBlock">
    <div
      class="col-md-12 d-flex justify-content-between align-items-center flex-wrap py-3 row-gap-3"
    >
      <div
        class="search-input search-input-container position-relative flex-md-grow-0 flex-grow-1"
      >
        <div class="position-absolute search-input__search-icon">
          <app-search-svg></app-search-svg>
        </div>
        <input
          type="text"
          [placeholder]="headerFilter.placeholder"
          [formControl]="searchControl"
        />
      </div>

      <div
        class="filter_buttons d-flex align-items-center gap-3 flex-md-grow-0 flex-grow-1"
      >
        <ng-container *ngIf="isCheckboxVisible">
          <button
            class="d-flex align-items-center gap-1"
            (click)="control.setValue(!control.value); $event.stopPropagation()"
          >
            <input
              type="checkbox"
              [checked]="control.value"
              [id]="'include-members-checkbox'"
              class="cursor-pointer"
            />
            <p class="m-0 fw-500">Include IndiaAI Members</p>
          </button>
        </ng-container>
        <ng-container *ngIf="isShowExportbtn">
          <button
            class="position-relative d-flex justify-content-center gap-2 align-items-center flex-md-grow-0 flex-grow-1"
            (click)="exportExcel.emit()"
          >
            <img src="assets/images/download2.svg" />Export Excel
          </button>
        </ng-container>
        <button
          class="position-relative d-flex justify-content-center gap-2 align-items-center flex-md-grow-0 flex-grow-1"
          (click)="onShowFilters.emit()"
        >
          <span
            *ngIf="isFilterApplied"
            class="filter-applied-indicator position-absolute"
          ></span>

          <span
            class="d-inline-block"
            [ngStyle]="{ width: '1.25rem', height: '1.25rem' }"
            [innerHTML]="filterSVG | safeHTML"
          ></span>
          <span>Filter</span>
        </button>

        <div *ngIf="showSort" class="dropdown">
          <button
            class="d-flex justify-content-center gap-2 align-items-center flex-md-grow-0 flex-grow-1 dropdown-toggle"
            data-bs-toggle="dropdown"
          >
            <span
              class="d-inline-block"
              [ngStyle]="{ width: '1.25rem', height: '1.25rem' }"
              [innerHTML]="sortingSVG | safeHTML"
            ></span>
            <span>Sorting: </span>
            <span>
              {{
                sortBy | getValueFromList : sortByOptions : "value" : "label"
              }}
            </span>
          </button>

          <ul class="dropdown-menu w-100">
            <li *ngFor="let option of sortByOptions; trackBy: trackByValue">
              <button
                [ngClass]="{ active: sortBy === option.value }"
                class="dropdown-item"
                type="button"
                (click)="onSortSelect.emit(option.value)"
              >
                {{ option.label }}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- Show Search Only (else block) -->
  <ng-template #showSearchOnlyBlock>
    <ng-container *ngIf="showSearchOnly">
      <div
        class="search-input search-input-container position-relative flex-md-grow-0 flex-grow-1 m-3"
      >
        <div class="position-absolute search-input__search-icon">
          <app-search-svg></app-search-svg>
        </div>
        <input
          type="text"
          [placeholder]="headerFilter.placeholder"
          [formControl]="searchControl"
        />
      </div>
    </ng-container>
  </ng-template>
</div>
